import * as React from 'react';
import { SVGProps } from 'react';

export const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.3889 6.94444V8.83333H6.94444V6.94444H16.3889ZM16.3889 6H6.94444C6.69396 6 6.45374 6.0995 6.27662 6.27662C6.0995 6.45374 6 6.69396 6 6.94444V8.83333C6 9.08382 6.0995 9.32404 6.27662 9.50116C6.45374 9.67827 6.69396 9.77778 6.94444 9.77778H16.3889C16.6394 9.77778 16.8796 9.67827 17.0567 9.50116C17.2338 9.32404 17.3333 9.08382 17.3333 8.83333V6.94444C17.3333 6.69396 17.2338 6.45374 17.0567 6.27662C16.8796 6.0995 16.6394 6 16.3889 6Z'
      fill='black'
    />
    <path
      d='M8.83333 11.6671V16.3893H6.94444V11.6671H8.83333ZM8.83333 10.7227H6.94444C6.69396 10.7227 6.45374 10.8222 6.27662 10.9993C6.0995 11.1764 6 11.4166 6 11.6671V16.3893C6 16.6398 6.0995 16.88 6.27662 17.0571C6.45374 17.2343 6.69396 17.3338 6.94444 17.3338H8.83333C9.08382 17.3338 9.32404 17.2343 9.50116 17.0571C9.67827 16.88 9.77778 16.6398 9.77778 16.3893V11.6671C9.77778 11.4166 9.67827 11.1764 9.50116 10.9993C9.32404 10.8222 9.08382 10.7227 8.83333 10.7227Z'
      fill='black'
    />
    <path
      d='M16.3889 11.6671V16.3893H11.6667V11.6671H16.3889ZM16.3889 10.7227H11.6667C11.4162 10.7227 11.176 10.8222 10.9989 10.9993C10.8217 11.1764 10.7222 11.4166 10.7222 11.6671V16.3893C10.7222 16.6398 10.8217 16.88 10.9989 17.0571C11.176 17.2343 11.4162 17.3338 11.6667 17.3338H16.3889C16.6394 17.3338 16.8796 17.2343 17.0567 17.0571C17.2338 16.88 17.3333 16.6398 17.3333 16.3893V11.6671C17.3333 11.4166 17.2338 11.1764 17.0567 10.9993C16.8796 10.8222 16.6394 10.7227 16.3889 10.7227Z'
      fill='black'
    />
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
  </svg>
);

export const NavHomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4099_20796)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.12553 8.86323L10.334 4.18085L15.5422 8.86291V15.965H12.7094V10.965H7.70936V15.965H5.12553V8.86323ZM3.87553 8.30611L1.66663 10.2919L2.50231 11.2215L3.87553 9.98696V17.215H8.95936V12.215H11.4594V17.215H16.7922V9.98664L18.1658 11.2215L19.0015 10.2919L16.7922 8.30578V8.25667H16.7376L10.334 2.5L3.93053 8.25667H3.87553V8.30611Z'
        fill={props.fill || 'black'}
      />
    </g>
    <defs>
      <clipPath id='clip0_4099_20796'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const FilesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4534_7172)'>
      <path
        d='M18.4123 8.15581L12.2584 4.7336C12.18 4.68998 12.0908 4.66699 12 4.66699C11.9092 4.66699 11.82 4.68998 11.7416 4.7336L5.58775 8.15581C5.51033 8.19887 5.4461 8.26052 5.40147 8.33461C5.35683 8.40871 5.33334 8.49267 5.33334 8.57811V15.4225C5.33334 15.508 5.35683 15.5919 5.40147 15.666C5.4461 15.7401 5.51033 15.8018 5.58775 15.8448L11.7416 19.2671C11.82 19.3107 11.9092 19.3337 12 19.3337C12.0908 19.3337 12.18 19.3107 12.2584 19.2671L18.4123 15.8448C18.4897 15.8018 18.5539 15.7401 18.5986 15.666C18.6432 15.5919 18.6667 15.508 18.6667 15.4225V8.57811C18.6667 8.49267 18.6432 8.40871 18.5986 8.33461C18.5539 8.26052 18.4897 8.19887 18.4123 8.15581ZM12 5.72188L17.1362 8.57811L12 11.4343L6.86381 8.57811L12 5.72188ZM6.35898 9.42936L11.4872 12.281V17.9935L6.35898 15.1418V9.42936ZM12.5128 17.9935V12.281L17.641 9.42936V15.1418L12.5128 17.9935Z'
        fill='black'
      />
    </g>
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
    <defs>
      <clipPath id='clip0_4534_7172'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export const ProjectsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4534_7183)'>
      <path
        d='M9.70001 7.65465L11.3286 9.3386L11.6048 9.62996H17.7143V16.8645H6.28572V7.65465H9.70001ZM9.70001 6.66699H6.28572C6.03314 6.66699 5.7909 6.77105 5.61229 6.95627C5.43368 7.14149 5.33334 7.3927 5.33334 7.65465V16.8645C5.33334 17.1265 5.43368 17.3777 5.61229 17.5629C5.7909 17.7481 6.03314 17.8522 6.28572 17.8522H17.7143C17.9669 17.8522 18.2091 17.7481 18.3877 17.5629C18.5663 17.3777 18.6667 17.1265 18.6667 16.8645V9.62996C18.6667 9.36801 18.5663 9.1168 18.3877 8.93158C18.2091 8.74636 17.9669 8.6423 17.7143 8.6423H12L10.3762 6.95835C10.2876 6.86592 10.1822 6.79259 10.0662 6.74259C9.95013 6.69258 9.82568 6.66689 9.70001 6.66699Z'
        fill='black'
      />
    </g>
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
    <defs>
      <clipPath id='clip0_4534_7183'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export const DiverseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4534_7195)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.83332 6.83301H5.16666V17.833H18.1667V7.46132L13.5 10.5418V7.46132L8.83332 10.5418V6.83301ZM6.16666 16.833V7.83301H7.83332V12.4001L12.5 9.31964V12.4001L17.1667 9.31964V16.833H15.1667V13.1663H12.1667V16.833H6.16666ZM13.1667 16.833H14.1667V14.1663H13.1667V16.833Z'
        fill='black'
      />
    </g>
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
    <defs>
      <clipPath id='clip0_4534_7195'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export const SharedWithMeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.6667 6C11.1611 6 11.6445 6.14662 12.0556 6.42133C12.4667 6.69603 12.7871 7.08648 12.9764 7.54329C13.1656 8.00011 13.2151 8.50277 13.1186 8.98773C13.0222 9.47268 12.7841 9.91814 12.4344 10.2678C12.0848 10.6174 11.6393 10.8555 11.1544 10.952C10.6694 11.0484 10.1668 10.9989 9.70995 10.8097C9.25313 10.6205 8.86269 10.3 8.58798 9.88893C8.31328 9.4778 8.16666 8.99445 8.16666 8.5C8.16666 7.83696 8.43005 7.20107 8.89889 6.73223C9.36773 6.26339 10.0036 6 10.6667 6ZM10.6667 5C9.97442 5 9.29773 5.20527 8.72216 5.58986C8.14659 5.97444 7.69799 6.52107 7.43308 7.16061C7.16817 7.80015 7.09886 8.50388 7.23391 9.18282C7.36896 9.86175 7.7023 10.4854 8.19178 10.9749C8.68127 11.4644 9.30491 11.7977 9.98384 11.9327C10.6628 12.0678 11.3665 11.9985 12.006 11.7336C12.6456 11.4687 13.1922 11.0201 13.5768 10.4445C13.9614 9.86892 14.1667 9.19223 14.1667 8.5C14.1667 7.57174 13.7979 6.6815 13.1415 6.02513C12.4852 5.36875 11.5949 5 10.6667 5Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.9108 13H9.16666C8.2384 13 7.34816 13.3687 6.69178 14.0251C6.03541 14.6815 5.66666 15.5717 5.66666 16.5V19H6.66666V16.5C6.66666 15.837 6.93005 15.2011 7.39889 14.7322C7.86773 14.2634 8.50362 14 9.16666 14H10.9108V13Z'
      fill='black'
    />
    <circle cx='17.0267' cy='12.7847' r='1.05814' stroke='black' />
    <circle cx='17.0266' cy='17.9038' r='1.05814' stroke='black' />
    <circle cx='12.711' cy='15.4165' r='1.05814' stroke='black' />
    <line x1='16.3374' y1='13.2182' x2='13.6386' y2='14.7763' stroke='black' />
    <line x1='16.2508' y1='17.3129' x2='13.456' y2='15.6993' stroke='black' />
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
  </svg>
);

export const SettingsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4534_7232)'>
      <path
        d='M17.1849 8.81482H15.623C15.4325 7.93863 14.6706 7.29102 13.7563 7.29102C12.842 7.29102 12.0801 7.93863 11.8896 8.81482H6.51822V9.57673H11.8896C12.0801 10.4529 12.842 11.1005 13.7563 11.1005C14.6706 11.1005 15.4325 10.4529 15.623 9.57673H17.1849V8.81482ZM13.7563 10.3386C13.1087 10.3386 12.6135 9.8434 12.6135 9.19578C12.6135 8.54816 13.1087 8.05292 13.7563 8.05292C14.4039 8.05292 14.8992 8.54816 14.8992 9.19578C14.8992 9.8434 14.4039 10.3386 13.7563 10.3386Z'
        fill='black'
      />
      <path
        d='M6.51822 14.9097H8.08012C8.2706 15.7859 9.0325 16.4335 9.94679 16.4335C10.8611 16.4335 11.623 15.7859 11.8135 14.9097H17.1849V14.1478H11.8135C11.623 13.2716 10.8611 12.624 9.94679 12.624C9.0325 12.624 8.2706 13.2716 8.08012 14.1478H6.51822V14.9097ZM9.94679 13.3859C10.5944 13.3859 11.0896 13.8812 11.0896 14.5288C11.0896 15.1764 10.5944 15.6716 9.94679 15.6716C9.29917 15.6716 8.80393 15.1764 8.80393 14.5288C8.80393 13.8812 9.29917 13.3859 9.94679 13.3859Z'
        fill='black'
      />
    </g>
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
    <defs>
      <clipPath id='clip0_4534_7232'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export const UpgradeToProIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4534_7245)'>
      <path
        d='M15.4286 9.67578L16.0354 10.8039L17.3333 10.9596L16.3809 11.8069L16.5714 13.0602L15.4286 12.3551L14.2857 13.0602L14.4762 11.8069L13.5239 10.9596L14.8572 10.8039L15.4286 9.67578Z'
        fill='black'
      />
      <path
        d='M14.2855 17.1962H13.5236V15.316C13.523 14.8175 13.3222 14.3395 12.9651 13.9871C12.608 13.6346 12.1239 13.4363 11.6189 13.4357H9.33325C8.82827 13.4363 8.34415 13.6346 7.98708 13.9871C7.63 14.3395 7.42914 14.8175 7.42854 15.316V17.1962H6.66666V15.316C6.66748 14.6181 6.94869 13.949 7.4486 13.4555C7.9485 12.962 8.62628 12.6844 9.33325 12.6836H11.6189C12.3259 12.6844 13.0037 12.962 13.5036 13.4555C14.0035 13.949 14.2847 14.6181 14.2855 15.316V17.1962Z'
        fill='black'
      />
      <path
        d='M10.4758 7.41909C10.8525 7.41909 11.2207 7.52937 11.534 7.73597C11.8472 7.94258 12.0913 8.23624 12.2355 8.57981C12.3797 8.92338 12.4174 9.30144 12.3439 9.66617C12.2704 10.0309 12.089 10.3659 11.8226 10.6289C11.5562 10.8919 11.2168 11.0709 10.8474 11.1435C10.4779 11.216 10.0949 11.1788 9.74687 11.0365C9.39883 10.8942 9.10135 10.6532 8.89206 10.344C8.68277 10.0348 8.57106 9.67123 8.57106 9.29935C8.57106 8.80068 8.77173 8.32243 9.12894 7.96981C9.48614 7.61719 9.97061 7.41909 10.4758 7.41909ZM10.4758 6.66699C9.94837 6.66699 9.43281 6.82138 8.99429 7.11062C8.55577 7.39987 8.21399 7.81099 8.01216 8.29199C7.81033 8.77299 7.75752 9.30227 7.86041 9.8129C7.9633 10.3235 8.21727 10.7926 8.5902 11.1607C8.96313 11.5289 9.43828 11.7796 9.95554 11.8811C10.4728 11.9827 11.009 11.9306 11.4962 11.7313C11.9835 11.5321 12.4 11.1947 12.693 10.7618C12.986 10.3289 13.1424 9.81998 13.1424 9.29935C13.1424 8.60121 12.8614 7.93166 12.3613 7.43799C11.8613 6.94433 11.183 6.66699 10.4758 6.66699Z'
        fill='black'
      />
    </g>
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
    <defs>
      <clipPath id='clip0_4534_7245'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export const UpgradeToBusinessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4534_7328)'>
      <path
        d='M16.3791 19.5723H15.3144V18.5076C15.3139 18.0841 15.1455 17.6782 14.8461 17.3787C14.5467 17.0793 14.1407 16.9109 13.7173 16.9104H11.5878C11.1643 16.9109 10.7584 17.0793 10.4589 17.3787C10.1595 17.6782 9.99111 18.0841 9.99065 18.5076V19.5723H8.9259V18.5076C8.92673 17.8019 9.20745 17.1253 9.70646 16.6263C10.2055 16.1272 10.8821 15.8465 11.5878 15.8457H13.7173C14.423 15.8465 15.0995 16.1272 15.5986 16.6263C16.0976 17.1253 16.3783 17.8019 16.3791 18.5076V19.5723Z'
        fill='black'
      />
      <path
        d='M12.6526 10.5228C12.9685 10.5228 13.2773 10.6164 13.54 10.7919C13.8026 10.9674 14.0073 11.2168 14.1282 11.5087C14.2491 11.8005 14.2807 12.1216 14.2191 12.4315C14.1574 12.7413 14.0053 13.0258 13.782 13.2492C13.5586 13.4726 13.274 13.6247 12.9642 13.6863C12.6544 13.7479 12.3333 13.7163 12.0415 13.5954C11.7496 13.4745 11.5002 13.2698 11.3247 13.0072C11.1492 12.7445 11.0555 12.4358 11.0555 12.1199C11.0555 11.6963 11.2238 11.2901 11.5233 10.9905C11.8228 10.691 12.2291 10.5228 12.6526 10.5228ZM12.6526 9.45801C12.1262 9.45801 11.6115 9.61412 11.1738 9.90661C10.7361 10.1991 10.3949 10.6148 10.1934 11.1012C9.99194 11.5876 9.93922 12.1228 10.0419 12.6392C10.1446 13.1555 10.3982 13.6298 10.7704 14.0021C11.1427 14.3744 11.617 14.6279 12.1333 14.7306C12.6497 14.8333 13.1849 14.7806 13.6713 14.5791C14.1577 14.3776 14.5734 14.0365 14.8659 13.5987C15.1584 13.161 15.3145 12.6463 15.3145 12.1199C15.3145 11.4139 15.0341 10.7368 14.5349 10.2377C14.0357 9.73845 13.3586 9.45801 12.6526 9.45801Z'
        fill='black'
      />
      <path
        d='M8.39332 11.0547H7.32858C6.62286 11.0555 5.94629 11.3362 5.44728 11.8352C4.94826 12.3343 4.66755 13.0108 4.66672 13.7166V15.846H5.73146V13.7166C5.73193 13.2931 5.90034 12.8872 6.19976 12.5877C6.49918 12.2883 6.90514 12.1199 7.32858 12.1194H8.39332V11.0547Z'
        fill='black'
      />
      <path
        d='M8.39337 5.73076C8.70925 5.73076 9.01803 5.82443 9.28068 5.99993C9.54332 6.17542 9.74803 6.42485 9.86891 6.71669C9.98979 7.00853 10.0214 7.32965 9.9598 7.63946C9.89817 7.94927 9.74606 8.23385 9.5227 8.45722C9.29934 8.68058 9.01476 8.83269 8.70495 8.89431C8.39514 8.95594 8.07401 8.92431 7.78218 8.80343C7.49034 8.68255 7.24091 8.47784 7.06541 8.21519C6.88992 7.95255 6.79625 7.64376 6.79625 7.32788C6.79625 6.9043 6.96452 6.49807 7.26404 6.19855C7.56355 5.89903 7.96979 5.73076 8.39337 5.73076ZM8.39337 4.66602C7.8669 4.66602 7.35226 4.82213 6.91452 5.11462C6.47678 5.40711 6.1356 5.82284 5.93413 6.30923C5.73266 6.79562 5.67995 7.33083 5.78265 7.84719C5.88536 8.36354 6.13888 8.83784 6.51115 9.2101C6.88342 9.58237 7.35771 9.83589 7.87407 9.9386C8.39042 10.0413 8.92563 9.9886 9.41202 9.78712C9.89841 9.58565 10.3141 9.24448 10.6066 8.80673C10.8991 8.36899 11.0552 7.85435 11.0552 7.32788C11.0552 6.62191 10.7748 5.94485 10.2756 5.44566C9.77639 4.94646 9.09934 4.66602 8.39337 4.66602Z'
        fill='black'
      />
      <path
        d='M16.8574 4.79492L17.6008 6.17695L19.1907 6.36766L18.0241 7.40557L18.2574 8.94099L16.8574 8.07723L15.4574 8.94099L15.6907 7.40557L14.5241 6.36766L16.1574 6.17695L16.8574 4.79492Z'
        fill='black'
      />
    </g>
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
    <defs>
      <clipPath id='clip0_4534_7328'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export const NewTeamIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4115_24035)'>
      <rect
        x='16.1395'
        y='4.66602'
        width='1.06475'
        height='5.32373'
        fill='black'
      />
      <rect
        x='14.0099'
        y='7.75391'
        width='1.06475'
        height='5.32372'
        transform='rotate(-90 14.0099 7.75391)'
        fill='black'
      />
      <path
        d='M16.3791 19.5723H15.3144V18.5076C15.3139 18.0841 15.1455 17.6782 14.8461 17.3787C14.5467 17.0793 14.1407 16.9109 13.7173 16.9104H11.5878C11.1643 16.9109 10.7584 17.0793 10.4589 17.3787C10.1595 17.6782 9.99111 18.0841 9.99065 18.5076V19.5723H8.9259V18.5076C8.92673 17.8019 9.20745 17.1253 9.70646 16.6263C10.2055 16.1272 10.8821 15.8465 11.5878 15.8457H13.7173C14.423 15.8465 15.0995 16.1272 15.5986 16.6263C16.0976 17.1253 16.3783 17.8019 16.3791 18.5076V19.5723Z'
        fill='black'
      />
      <path
        d='M12.6527 10.5228C12.9686 10.5228 13.2774 10.6164 13.54 10.7919C13.8027 10.9674 14.0074 11.2168 14.1283 11.5087C14.2491 11.8005 14.2808 12.1216 14.2191 12.4315C14.1575 12.7413 14.0054 13.0258 13.782 13.2492C13.5587 13.4726 13.2741 13.6247 12.9643 13.6863C12.6545 13.7479 12.3334 13.7163 12.0415 13.5954C11.7497 13.4745 11.5002 13.2698 11.3248 13.0072C11.1493 12.7445 11.0556 12.4358 11.0556 12.1199C11.0556 11.6963 11.2239 11.2901 11.5234 10.9905C11.8229 10.691 12.2291 10.5228 12.6527 10.5228ZM12.6527 9.45801C12.1262 9.45801 11.6116 9.61412 11.1739 9.90661C10.7361 10.1991 10.3949 10.6148 10.1935 11.1012C9.992 11.5876 9.93928 12.1228 10.042 12.6392C10.1447 13.1555 10.3982 13.6298 10.7705 14.0021C11.1428 14.3744 11.6171 14.6279 12.1334 14.7306C12.6498 14.8333 13.185 14.7806 13.6714 14.5791C14.1577 14.3776 14.5735 14.0365 14.866 13.5987C15.1585 13.161 15.3146 12.6463 15.3146 12.1199C15.3146 11.4139 15.0341 10.7368 14.5349 10.2377C14.0357 9.73845 13.3587 9.45801 12.6527 9.45801Z'
        fill='black'
      />
      <path
        d='M8.39335 11.0547H7.32861C6.62289 11.0555 5.94632 11.3362 5.44731 11.8352C4.94829 12.3343 4.66758 13.0108 4.66675 13.7166V15.846H5.73149V13.7166C5.73196 13.2931 5.90037 12.8872 6.19979 12.5877C6.49921 12.2883 6.90517 12.1199 7.32861 12.1194H8.39335V11.0547Z'
        fill='black'
      />
      <path
        d='M8.39343 5.73076C8.70931 5.73076 9.0181 5.82443 9.28074 5.99993C9.54338 6.17542 9.74809 6.42485 9.86897 6.71669C9.98985 7.00853 10.0215 7.32965 9.95986 7.63946C9.89823 7.94927 9.74612 8.23385 9.52276 8.45722C9.2994 8.68058 9.01482 8.83269 8.70501 8.89431C8.3952 8.95594 8.07407 8.92431 7.78224 8.80343C7.4904 8.68255 7.24097 8.47784 7.06548 8.21519C6.88998 7.95255 6.79631 7.64376 6.79631 7.32788C6.79631 6.9043 6.96458 6.49807 7.2641 6.19855C7.56361 5.89903 7.96985 5.73076 8.39343 5.73076ZM8.39343 4.66602C7.86696 4.66602 7.35232 4.82213 6.91458 5.11462C6.47684 5.40711 6.13566 5.82284 5.93419 6.30923C5.73272 6.79562 5.68001 7.33083 5.78272 7.84719C5.88542 8.36354 6.13894 8.83784 6.51121 9.2101C6.88348 9.58237 7.35778 9.83589 7.87413 9.9386C8.39048 10.0413 8.92569 9.9886 9.41208 9.78712C9.89847 9.58565 10.3142 9.24448 10.6067 8.80673C10.8992 8.36899 11.0553 7.85435 11.0553 7.32788C11.0553 6.62191 10.7748 5.94485 10.2756 5.44566C9.77645 4.94646 9.0994 4.66602 8.39343 4.66602Z'
        fill='black'
      />
    </g>
    <rect x='0.5' y='0.5' width='23' height='23' rx='11.5' stroke='#646464' />
    <defs>
      <clipPath id='clip0_4115_24035'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export const ToggleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='10'
    height='13'
    viewBox='0 0 8 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 12.5835L0 8.56289L0.56 8L4 11.4578L7.44 8L8 8.56289L4 12.5835Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 0.000448704L8 4.02109L7.44 4.58398L4 1.12623L0.559999 4.58398L0 4.02109L4 0.000448704Z'
      fill='black'
    />
  </svg>
);

export const CommunityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4355_19195)'>
      <path
        d='M12 5C10.6155 5 9.26216 5.41054 8.11101 6.17971C6.95987 6.94888 6.06266 8.04213 5.53285 9.32122C5.00303 10.6003 4.86441 12.0078 5.13451 13.3656C5.4046 14.7235 6.07129 15.9708 7.05026 16.9497C8.02922 17.9287 9.2765 18.5954 10.6344 18.8655C11.9922 19.1356 13.3997 18.997 14.6788 18.4672C15.9579 17.9373 17.0511 17.0401 17.8203 15.889C18.5895 14.7378 19 13.3845 19 12C19 10.1435 18.2625 8.36301 16.9497 7.05025C15.637 5.7375 13.8565 5 12 5ZM18 11.5H15C14.9416 9.65854 14.4646 7.85458 13.605 6.225C14.7893 6.54895 15.8457 7.22842 16.6316 8.17171C17.4175 9.115 17.8952 10.2767 18 11.5ZM12 18C11.8885 18.0075 11.7765 18.0075 11.665 18C10.6291 16.3481 10.0543 14.4491 10 12.5H14C13.9503 14.4477 13.3806 16.3466 12.35 18C12.2335 18.0082 12.1165 18.0082 12 18ZM10 11.5C10.0497 9.55234 10.6194 7.65341 11.65 6C11.8726 5.97498 12.0974 5.97498 12.32 6C13.3611 7.6504 13.9412 9.54953 14 11.5H10ZM10.38 6.225C9.52565 7.85582 9.05373 9.65972 9 11.5H6C6.10485 10.2767 6.58247 9.115 7.3684 8.17171C8.15432 7.22842 9.21072 6.54895 10.395 6.225H10.38ZM6.025 12.5H9.025C9.07718 14.3399 9.54739 16.1438 10.4 17.775C9.21943 17.4476 8.16739 16.7666 7.38528 15.8236C6.60317 14.8806 6.12848 13.7208 6.025 12.5ZM13.605 17.775C14.4646 16.1454 14.9416 14.3415 15 12.5H18C17.8952 13.7233 17.4175 14.885 16.6316 15.8283C15.8457 16.7716 14.7893 17.4511 13.605 17.775Z'
        fill='black'
      />
    </g>
    <rect
      x='0.5'
      y='0.5'
      width='23'
      height='23'
      rx='11.5'
      stroke='currentColor'
    />
    <defs>
      <clipPath id='clip0_4355_19195'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export const MoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='4'
    viewBox='0 0 14 4'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.95 1.99961C2.95 1.25402 2.34558 0.649609 1.6 0.649609C0.854416 0.649609 0.25 1.25402 0.25 1.99961C0.25 2.74519 0.854416 3.34961 1.6 3.34961C2.34558 3.34961 2.95 2.74519 2.95 1.99961Z'
      fill='black'
    />
    <path
      d='M8.34999 1.99961C8.34999 1.25402 7.74558 0.649609 6.99999 0.649609C6.25441 0.649609 5.64999 1.25402 5.64999 1.99961C5.64999 2.74519 6.25441 3.34961 6.99999 3.34961C7.74558 3.34961 8.34999 2.74519 8.34999 1.99961Z'
      fill='black'
    />
    <path
      d='M13.75 1.99961C13.75 1.25402 13.1456 0.649609 12.4 0.649609C11.6544 0.649609 11.05 1.25402 11.05 1.99961C11.05 2.74519 11.6544 3.34961 12.4 3.34961C13.1456 3.34961 13.75 2.74519 13.75 1.99961Z'
      fill='black'
    />
  </svg>
);

export const NoNotifications = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='36'
    height='49'
    viewBox='0 0 36 49'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle cx='18' cy='17.8447' r='17' fill='#D8D8D8' />
    <path
      d='M34.1308 37.8447H2.00781V35.6058L5.96041 31.784C6.23425 31.5193 6.38814 31.1603 6.38823 30.7859V25.1388C6.38823 22.1435 7.61891 19.2708 9.80954 17.1527C12.0002 15.0346 14.9713 13.8447 18.0693 13.8447C21.1674 13.8447 24.1385 15.0346 26.3291 17.1527C28.5197 19.2708 29.7504 22.1435 29.7504 25.1388V30.7859C29.7505 31.1603 29.9044 31.5193 30.1783 31.784L34.1308 35.6058V37.8447Z'
      fill='white'
    />
    <path
      d='M23.4998 25.8447C23.4998 28.8823 21.0373 31.3447 17.9998 31.3447C14.9622 31.3447 12.4998 28.8823 12.4998 25.8447C12.4998 22.8072 14.9622 20.3447 17.9998 20.3447C21.0373 20.3447 23.4998 22.8072 23.4998 25.8447Z'
      stroke='#D8D8D8'
      strokeWidth='3'
    />
    <path
      d='M10.2257 30.8599L9.69434 31.3892L10.2257 31.9185L12.0936 33.7793L12.625 34.3086L13.1563 33.7793L25.6092 21.374L26.1406 20.8447L25.6092 20.3154L23.7413 18.4546L23.2099 17.9253L22.6786 18.4546L10.2257 30.8599Z'
      fill='#D8D8D8'
      stroke='white'
      strokeWidth='1.5'
    />
    <path
      d='M30.8462 30.3425V30.7579L31.1404 31.051L34.8887 34.7849L35.5944 34.0765L34.8887 34.7849C34.9604 34.8563 35 34.9523 35 35.0517C35 35.0517 35 35.0517 35 35.0518V39.1896C35 39.2889 34.9604 39.385 34.8887 39.4564C34.8169 39.528 34.7186 39.5689 34.6154 39.5689H24.9231H23.9231V40.5689V41.9471C23.9221 42.7705 23.7482 43.5847 23.4123 44.3373C23.0765 45.09 22.586 45.7646 21.9724 46.3176C21.3587 46.8707 20.6354 47.2898 19.8489 47.5479C19.0668 47.8046 18.2396 47.8963 17.4199 47.8172C15.9258 47.6241 14.5558 46.8904 13.5707 45.7567C12.5826 44.6196 12.051 43.1599 12.0768 41.6575L12.0769 41.6489V41.6404V40.5689V39.5689H11.0769H1.38462C1.28137 39.5689 1.18313 39.528 1.1113 39.4565C1.03959 39.385 1 39.2889 1 39.1896V35.0518C1 35.0517 1 35.0517 1 35.0517C1.00004 34.9523 1.03963 34.8563 1.11129 34.7849L0.405554 34.0765L1.1113 34.7849L4.85959 31.051L5.15385 30.7579V30.3425V25.3971C5.15814 22.2279 6.34178 19.1723 8.4769 16.821C10.6123 14.4694 13.5478 12.9895 16.7162 12.6683L17.6154 12.5772V11.6734V9.84473H18.3846V11.6734V12.5772L19.2838 12.6683C22.4522 12.9895 25.3877 14.4694 27.5231 16.821C29.6584 19.1724 30.842 22.2284 30.8462 25.3978V30.3425ZM13.8462 39.5689H12.8462V40.5689V41.9482C12.8462 43.3121 13.3901 44.6194 14.357 45.5826C15.3239 46.5458 16.6344 47.0861 18 47.0861C19.3657 47.0861 20.6761 46.5458 21.643 45.5826C22.6099 44.6194 23.1538 43.3121 23.1538 41.9482V40.5689V39.5689H22.1538H13.8462ZM33.2308 38.8103H34.2308V37.8103V35.6228V35.2075L33.9365 34.9144L30.1884 31.1804L30.1883 31.1803C30.1166 31.109 30.077 31.013 30.0769 30.9137C30.0769 30.9136 30.0769 30.9136 30.0769 30.9135V25.3965C30.0769 22.2035 28.8036 19.142 26.5383 16.8854C24.2732 14.629 21.2018 13.362 18 13.362C14.7982 13.362 11.7268 14.629 9.46168 16.8854C7.1964 19.142 5.92308 22.2035 5.92308 25.3965V30.9135C5.92308 30.9136 5.92308 30.9136 5.92308 30.9137C5.923 31.013 5.8834 31.109 5.81174 31.1803L5.81162 31.1804L2.06347 34.9144L1.76923 35.2075V35.6228V37.8103V38.8103H2.76923H33.2308Z'
      fill='white'
      stroke='black'
      strokeWidth='2'
    />
  </svg>
);

export const FoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.96352 9.53711V5.55881L1.61795 5.55881L3.9148 7.87435L3.3665 8.42791L0 5.03659L3.3665 1.64527L3.9148 2.19987L1.61795 4.51436L8.96352 4.51436L8.96352 0.537109H10L10 9.53711H8.96352Z'
      fill='black'
    />
  </svg>
);
